<script setup lang="ts">
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        neutral: 'border-transparent bg-slate-800 text-slate-300',
        success: 'border-emerald-500/20 bg-emerald-500/10 text-emerald-400',
        warning: 'border-amber-500/20 bg-amber-500/10 text-amber-400',
        error: 'border-rad-red/20 bg-rad-red/10 text-rad-red',
        info: 'border-rad-blue/20 bg-rad-blue/10 text-rad-blue',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);

interface Props {
  variant?: VariantProps<typeof badgeVariants>['variant'];
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'neutral',
});
</script>

<template>
  <div :class="cn(badgeVariants({ variant }), props.class)">
    <slot />
  </div>
</template>